import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PLACEHOLDERS = [
  { url: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Modern home glazing" },
  { url: "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Glass shopfront" },
  { url: "https://images.unsplash.com/photo-1543710397-c21ee19e2b95?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Architectural glass facade" },
  { url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Residential windows" },
  { url: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Interior glass features" },
  { url: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Bathroom & shower glass" },
];

export default function Gallery() {
  const [photos, setPhotos] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((res) => setPhotos(res.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const items =
    photos.length > 0
      ? photos.map((p) => ({ url: `${API}/files/${p.storage_path}`, caption: p.caption || "Recent job" }))
      : PLACEHOLDERS;

  return (
    <section id="gallery" className="py-24 px-6 md:px-12 lg:px-24 bg-slate-50" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-4">Our work</p>
            <h2 className="font-outfit text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-slate-800" data-testid="gallery-heading">
              Recent jobs around South-West Sydney.
            </h2>
          </div>
          <a href="#contact" data-testid="gallery-enquire-link" className="text-sm font-semibold text-sky-600 hover:text-slate-900 transition-colors duration-200">
            Want work like this? Get in touch
          </a>
        </div>
        {loaded && photos.length === 0 && (
          <p className="mt-4 text-xs text-slate-400" data-testid="gallery-sample-note">Sample images shown — real project photos coming soon.</p>
        )}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1 bg-slate-200 border border-slate-200">
          {items.map((item, i) => (
            <figure key={i} className="group relative overflow-hidden bg-white aspect-[4/3]" data-testid={`gallery-item-${i}`}>
              <img
                src={item.url}
                alt={item.caption}
                loading="lazy"
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-slate-900/70 backdrop-blur-sm text-white text-xs font-medium px-4 py-2.5 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                {item.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
